<template>
	<a @click.prevent="visitBookingEngine({ ...props })">
		<slot />
	</a>
</template>

<script setup>
import { BookingEngineFactory } from '@becurioushq/mews';

const { locale } = useI18n();
const bookingEngine = useState('bookingEngine', () => {});

const props = defineProps({
	arrival: { type: Date, default: null },
	departure: { type: Date, default: null },
	promo: { type: String, default: '' },
	roomid: { type: String, default: '' },
	language: { type: String, default: '' },
});

onMounted(() => {
	if (!bookingEngine.value) {
		const factory = new BookingEngineFactory({
			hotelID: 'e34d52e8-8e68-466f-b66a-a5192089b95b',
			primaryColor: '#a34026',
			mode: 'widget',
		});

		bookingEngine.value = factory.createBookingEngine();
	}
});

const visitBookingEngine = (options) => {
	if (!bookingEngine.value) {
		return null;
	}

	if (!options.language) {
		options = { ...options, language: locale.value };
	}

	return bookingEngine.value.visitUrl(options);
};

useHead({
	script: [
		{
			hid: 'booking-engine',
			src: 'https://api.mews.com/distributor/distributor.min.js',
		},
	],
});
</script>
<style lang="scss" scoped>
a {
	color: #fff;
	cursor: pointer;

	&:hover {
		text-decoration: none;
	}
}
</style>
